import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useUserConventions } from "@seabrookstudios/pitch2table";
import { useMyProfile } from "@seabrookstudios/pitch2table";
import { DateTime } from "luxon";
import { ConventionListEntry } from "../events/ListEntry";
import Skeleton from "@mui/material/Skeleton";

export const UpcomingEventsCard = () => {
  const { data: profile } = useMyProfile();
  const { data: events = [], isLoading } = useUserConventions(profile?.id);

  const now = DateTime.now();
  const nextMonth = now.plus({ months: 1 });

  const upcomingEvents = events.filter((event) => {
    if (!event.startDate) return false;

    const eventDate = DateTime.fromMillis(event.startDate);
    return eventDate >= now && eventDate <= nextMonth;
  });

  if (upcomingEvents.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader
        title="Upcoming Events"
        subheader={upcomingEvents.length > 0 ? "Are you prepared?" : "No upcoming events"}
      />
      <CardContent>
        {isLoading ? (
          <Skeleton variant="rectangular" height={100} />
        ) : (
          <List>
            {upcomingEvents.map((event) => (
              <ListItem key={event.id} disableGutters disablePadding>
                <ConventionListEntry event={event} />
              </ListItem>
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  );
};
